import React, { useState } from 'react'
import { IconButton, Menu, MenuItem, Tooltip, ListItemIcon, Typography } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined'
import ProcessTimeline from './ProcessTimeline' // Adjust import path
import { PROCESS_ACTIVITY_STATUSES, PROCESS_VERSION } from '../../utility/constants'

export default function TaskKebabMenu({
  task,
  openDeleteDialog,
  openDelegateDialog,
  onPreviewClick,

  teamDetails,
}) {
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Tooltip title="More actions">
        <IconButton
          aria-label="more"
          aria-controls={open ? 'task-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          size="small"
          sx={{
            padding: '0px 5px',
            '&:hover': {
              padding: '0px 5px', // reinforce padding on hover
            },
          }}
        >
          <MoreVertIcon sx={{ fontSize: 15, color: '#656D92' }} />
        </IconButton>
      </Tooltip>

      <Menu
        id="task-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          elevation: 0,
          sx: {
            borderRadius: '4px',
            boxShadow: '0 5px 10px rgba(30,32,37,.12)',
            animation: 'DropDownSlideDown 300ms ease-in-out',
            animationFillMode: 'both',
          },
        }}
        MenuListProps={{
          sx: {
            paddingTop: '3px',
            paddingBottom: '3px',

            '& .MuiMenuItem-root:hover': {
              backgroundColor: '#eff2f7',
            },
          },
        }}
      >
        <MenuItem
          onClick={() => onPreviewClick(task.process_id)}
          sx={{ minHeight: '32px', padding: '5px 15px' }}
        >
          <ListItemIcon sx={{ minWidth: '20px !important', mr: 0.5 }}>
            <VisibilityOutlinedIcon sx={{ fontSize: '16px' }} />
          </ListItemIcon>
          <span style={{ fontSize: '11px', color: '#484A54' }}>Preview</span>
        </MenuItem>
        <MenuItem sx={{ minHeight: '32px', padding: '5px 15px' }}>
          <ListItemIcon sx={{ minWidth: '20px !important', mr: 0.5 }}>
            <ProcessTimeline
              sx={{ fontSize: '16px' }}
              task={task}
              processReferanceNum={task.process_reference_num}
              processTemplateId={task.process_template_id}
              templateRoutes={task.process_route_templates}
              processTemplates={task}
              showInTaskCard={true}
            />
          </ListItemIcon>
        </MenuItem>

        {task.process_activity_status === PROCESS_ACTIVITY_STATUSES.ACTIVE &&
          task.process_version === PROCESS_VERSION.VERSION &&
          task.is_start && (
            <MenuItem
              onClick={() => {
                openDeleteDialog()
                handleClose()
              }}
              sx={{ minHeight: '32px', padding: '5px 15px' }}
            >
              <ListItemIcon sx={{ minWidth: '20px !important', mr: 0.5 }}>
                <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
              </ListItemIcon>
              <span style={{ fontSize: '11px', color: '#484A54' }}>Delete</span>
            </MenuItem>
          )}

        {task.process_activity_status === PROCESS_ACTIVITY_STATUSES.ACTIVE &&
          task.delegation_team_ids?.length > 0 &&
          task.is_delegatable &&
          teamDetails?.length > 0 && (
            <MenuItem
              onClick={() => {
                openDelegateDialog(task)
                handleClose()
              }}
              sx={{ minHeight: '32px', padding: '5px 15px' }}
            >
              <ListItemIcon sx={{ minWidth: '20px !important', mr: 0.5 }}>
                <PeopleOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
              </ListItemIcon>
              <span style={{ fontSize: '11px', color: '#484A54' }}>Delegate</span>
            </MenuItem>
          )}
      </Menu>
    </>
  )
}
